// extracted by mini-css-extract-plugin
export var filterIncDec = "_f0-0";
export var leftBorder = "_f0-1";
export var rightBorder = "_f0-2";
export var stringInput = "_f0-3";